import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {FlexLayoutModule} from '@angular/flex-layout';
import {HotTableModule} from '@handsontable/angular';
import {OrderModule} from 'ngx-order-pipe';

import {ZendeskWidgetComponent} from './zendesk-widget/zendesk-widget.component';

import {DialogConfirmRemoveComponent} from './dialog-confirm-remove/dialog-confirm-remove.component';

import {RouterOutletComponent} from './router-outlet/router-outlet.component';
import {RouterOutletDynamicComponent} from './router-outlet-dynamic/router-outlet-dynamic.component';
import {SidenavComponent} from './sidenav/sidenav.component';
import {Sidenav2Component} from './sidenav2/sidenav.component';
import {SidenavItemComponent} from './sidenav-item/sidenav-item.component';
import {NavbarComponent} from './navbar/navbar.component';

import {TabHeaderComponent} from './tab-header/tab-header.component';
import {DashboardFiltrosComponent} from './dashboard-filtros/dashboard-filtros.component';

import {IframeComponent} from './iframe/iframe.component';
import {IframePageComponent} from './iframe-page/iframe-page.component';

import {KanbanComponent} from './templates/kanban/kanban.component';
import {CardsComponent} from './templates/cards/cards.component';

import {GanttComponent} from './templates/gantt/gantt.component';
import {GanttTimeReferenceComponent} from './templates/gantt/gantt-time-reference.component';
import {GanttSlideComponent} from './templates/gantt/gantt-slide.component';
import {GanttGroupComponent} from './templates/gantt/gantt-group.component';

import {
  MatSidenavModule, MatDialogModule, MatTooltipModule, MatTreeModule,
  MatSnackBarModule, MatProgressBarModule, MatTabsModule, MatListModule,
  MatToolbarModule, MatCardModule, MatButtonModule, MatMenuModule, MatIconModule,
  MatInputModule, MatRadioModule, MatSelectModule, MatCheckboxModule, MatSliderModule,
  MatDatepickerModule, MatNativeDateModule
} from '@angular/material';


import {DxChartModule, DxPieChartModule, DxPopoverModule, DxButtonModule, DxSchedulerModule} from 'devextreme-angular';

import {GridsterModule} from 'angular-gridster2';
import {PaginaDinamicaComponent} from './pagina-dinamica/pagina-dinamica.component';
import {TabsDinamicasComponent} from './tabs-dinamicas/tabs-dinamicas.component';
import {FormularioDinamicoModule} from './formulario-dinamico/formulario-dinamico.module';
import {FormularioDinamico2Module} from './formulario-dinamico2/formulario-dinamico2.module';
import {FormularioDinamicoComponent} from './formulario-dinamico/formulario-dinamico.component';
import {ComponenteDinamicoDirective} from './componente-dinamico/componente-dinamico.directive';
import {IframePageDiferentesComponent} from './iframe-page-diferentes/iframe-page-diferentes.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    HotTableModule.forRoot(),
    OrderModule,

    MatTooltipModule, MatTreeModule,
    MatSidenavModule, MatDialogModule, MatSnackBarModule, MatProgressBarModule, MatTabsModule,
    MatListModule, MatToolbarModule, MatCardModule, MatButtonModule,
    MatMenuModule, MatIconModule, MatInputModule, MatRadioModule,
    MatSelectModule, MatCheckboxModule, MatSliderModule, MatDatepickerModule, MatNativeDateModule,

    DxChartModule, DxPieChartModule, DxPopoverModule, DxButtonModule, DxSchedulerModule,

    GridsterModule
  ],
  declarations: [
    ZendeskWidgetComponent,
    DialogConfirmRemoveComponent,
    SidenavComponent, Sidenav2Component, SidenavItemComponent,
    NavbarComponent,

    RouterOutletComponent,
    RouterOutletDynamicComponent,

    PaginaDinamicaComponent, TabsDinamicasComponent, ComponenteDinamicoDirective,

    TabHeaderComponent, DashboardFiltrosComponent,

    IframeComponent, IframePageComponent, IframePageDiferentesComponent,

    KanbanComponent,
    CardsComponent,

    GanttComponent, GanttTimeReferenceComponent, GanttGroupComponent, GanttSlideComponent
  ],
  entryComponents: [
    DialogConfirmRemoveComponent,
    RouterOutletComponent,
    PaginaDinamicaComponent, TabsDinamicasComponent, FormularioDinamicoComponent,
    IframeComponent, IframePageComponent, IframePageDiferentesComponent,
    KanbanComponent, CardsComponent
  ],
  exports: [
    FlexLayoutModule, FormsModule, ReactiveFormsModule, OrderModule, HotTableModule, MatListModule,
    MatTooltipModule, MatTreeModule,
    MatSidenavModule, MatDialogModule, MatSnackBarModule, MatProgressBarModule,
    MatTabsModule, MatMenuModule, MatToolbarModule,
    MatCardModule, MatButtonModule, MatIconModule,
    MatInputModule, MatRadioModule, MatSelectModule, MatCheckboxModule,
    MatSliderModule, MatDatepickerModule, MatNativeDateModule,

    DxChartModule, DxPieChartModule, DxPopoverModule, DxButtonModule, DxSchedulerModule,

    GridsterModule,

    ZendeskWidgetComponent, DialogConfirmRemoveComponent,
    RouterOutletComponent, RouterOutletDynamicComponent,
    NavbarComponent, SidenavComponent, Sidenav2Component,

    PaginaDinamicaComponent, TabsDinamicasComponent, FormularioDinamicoModule, FormularioDinamico2Module,
    ComponenteDinamicoDirective,
    TabHeaderComponent, DashboardFiltrosComponent,
    IframeComponent, IframePageComponent, IframePageDiferentesComponent,

    // Templates
    KanbanComponent,
    CardsComponent,

    GanttComponent,
    GanttTimeReferenceComponent,
    GanttGroupComponent,
    GanttSlideComponent]
})
export class SharedModule {
}
